import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const NotFound: React.FC = () => {
  const { currentUser } = useAuth();

  // Redirect based on authentication status
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to="/login" replace />;
};

export default NotFound;
